module.exports = __webpack_public_path__ + "static/img/vip-bg1.69f4c46.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/vip-bg1.png
// module id = XyWN
// module chunks = 0